export default "__VITE_PUBLIC_ASSET__63ec7e14__"